import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shimmer } from "@/components/skeleton/Skeletons";

export function AdminGuard({ children }) {
  const { status, isAdmin } = useAuth();
  if (status === "loading")
    return (
      <div className="pk-container pt-32">
        <Shimmer className="h-40 rounded-[20px]" />
      </div>
    );
  if (!isAdmin) return <Navigate to={status === "guest" ? "/login" : "/"} replace state={{ from: window.location.pathname }} />;
  return children;
}
